import React from 'react';
import { StarFilled } from '@ant-design/icons';

const RatingIndicator = ({ value }) => {

  const renderStars = () => {
    const elements = [];
    for (let index = 0; index < value; index++) {
      elements.push(<StarFilled style={{ color: 'gold' }} />);
    }
    return elements;
  };

  return (
    <span>
      {renderStars()}
    </span>
  )
}

export default RatingIndicator;